import * as React from 'react';
import { CSSProperties } from 'react';

const defaultProps = (active: boolean) => ({
  fill: active ? '#FACE3A' : '#000000',
  height: '32',
  style: {display: 'block'},
  version: '1.1',
  viewBox: '0 0 16 32',
  width: '16',
  xmlns: 'http://www.w3.org/2000/svg',
});

interface IImageProps {
  active: boolean;
}

export const LineStartImage = (props: IImageProps) => (
  <svg {...defaultProps(props.active)}>
    <rect width="16" height="8" x="0" y="12" ry="1" rx="1"/>
    <rect width="4" height="16" x="6" y="16"/>
  </svg>
);

export const LineNormalImage = (props: IImageProps) => (
  <svg {...defaultProps(props.active)}>
    <rect width="4" height="16" x="6" y="0"/>
    <rect width="16" height="8" x="0" y="12" ry="1" rx="1"/>
    <rect width="4" height="16" x="6" y="16"/>
  </svg>
);

export const LineMainImage = (props: IImageProps) => (
  <svg {...defaultProps(props.active)}>
    <rect width="4" height="16" x="6" y="0"/>
    <rect width="16" height="20" x="0" y="6" ry="1" rx="1"/>
    <rect width="4" height="16" x="6" y="16"/>
  </svg>
);

export const LineEndImage = (props: IImageProps) => (
  <svg {...defaultProps(props.active)}>
    <rect width="4" height="16" x="6" y="0"/>
    <rect width="16" height="8" x="0" y="12" ry="1" rx="1"/>
  </svg>
);

interface IIconProps {
  style?: CSSProperties;
}

export const MapImage = (props: IIconProps) => (
  <svg version="1.1" style={props.style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 490 490">
    <g>
      <path d="M335.529,99.857v74.42h-15.313v-72.848L171.009,5.241v72.084h-15.312V3.659L0,82.979V490l155.697-97.058v-78.886h15.312
			v78.91l149.207,93.013V411h15.313v73.679L490,391.948V0L335.529,99.857z M171.009,271.528h-15.312v-54.573h15.312V271.528z
			M171.009,174.426h-15.312v-54.573h15.312V174.426z M335.529,368.472h-15.313v-54.566h15.313V368.472z M335.529,271.378h-15.313
			v-54.573h15.313V271.378z"/>
    </g>
  </svg>
);

export const NightImage = (props: IIconProps) => (
  <svg fill="#000000" version="1.1" style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.09 100">
    <path d="M65.407,80.003C43.315,80.003,25.413,62.09,25.413,40c0-19.454,13.893-35.629,32.292-39.226C55.177,0.378,52.641,0,49.997,0
	C22.381,0,0,22.388,0,50.002C0,77.611,22.381,100,49.997,100C73.1,100,92.355,84.25,98.09,62.951
	C90.852,73.238,78.936,80.003,65.407,80.003z"/>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/stadtbus/line_images.tsx